import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    event: "",
    date: "",
    images: [],
};

const gallerySlice = createSlice({
    name: "gallery",
    initialState,
    reducers: {
        setGallery: (state, action) => {
            state.event = action.payload.event;
            state.date =  action.payload.date;
            state.images = action.payload.images;
        },
    },
});

export const { setGallery } = gallerySlice.actions;
export default gallerySlice.reducer;